import { Flex, MantineStyleProps, Text } from '@mantine/core'
import React from 'react'
export interface IQuizLabelParameter {
    required?: boolean
    label: string
    description?: string
    children?: React.ReactNode
    c?: MantineStyleProps['c']
    fw?: MantineStyleProps['fw']
}
const QuizLabelParameter = ({
    label,
    description,
    required,
    c = 'text.2',
    fw = 'normal',
    children,
}: IQuizLabelParameter) => {
    return (
        <Flex direction='column'>
            <Flex direction='row' gap='4px' wrap='wrap'>
                <Text fw={fw} c={c}>
                    {label}
                </Text>
                <Text c='fuchasia.4'>{required ? '*' : ''}</Text>
            </Flex>
            <Text c='text.1' maw={388}>
                {description}
            </Text>
            {children}
        </Flex>
    )
}

export default QuizLabelParameter
